import { render, staticRenderFns } from "./vsTextarea.vue?vue&type=template&id=638b6b1a&lang=html&"
import script from "./vsTextarea.vue?vue&type=script&lang=js&"
export * from "./vsTextarea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "vsTextarea.vue"
export default component.exports